import axios from '@/helpers/axios';
import {Researcher} from "@/types/models/researcher";

export async function fetchResearcher(id: string) {
    return await axios.get<Researcher>(`/researchers/${id}`).then(res => res.data);
}